// Todas las opciones de cata según el PRD de VINOTE

export const TIPOS_VINO = ["Blanco", "Rosado", "Tinto", "Espumoso", "Generoso", "Dulce"];

// ---- VISUAL ----
export const LIMPIDEZ = ["Limpio", "Transparente", "Turbio", "Opaco"];
export const BRILLANTEZ = ["Mate", "Ligero brillo", "Brillante", "Muy brillante", "Cristalino"];
export const COLOR_BLANCO = ["Incoloro", "Amarillo pálido", "Amarillo claro", "Amarillo limón", "Amarillo verdoso", "Amarillo canario", "Amarillo oro", "Dorado", "Oro viejo"];
export const COLOR_ROSADO = ["Rojo pálido", "Rosado claro", "Rosado intenso", "Rosa violáceo", "Rosa fresa", "Salmón", "Naranja", "Shallot", "Ocre", "Ámbar", "Teja"];
export const COLOR_TINTO = ["Púrpura", "Rubí", "Granate", "Rojo", "Rojo ciruela", "Ladrillo", "Caoba", "Ámbar", "Ocre", "Teja"];
export const INTENSIDAD_7 = ["Muy baja", "Baja", "Media (-)", "Media", "Media (+)", "Alta", "Muy alta"];
export const DENSIDAD = ["Muy ligera", "Ligera", "Media", "Alta", "Muy alta"];
export const CANTIDAD_3 = ["Baja", "Media", "Alta"];
export const SI_NO = ["No", "Sí"];

// ---- OLFATIVO ----
export const ESTADO_OLF = ["Muy joven", "Joven", "Maduro", "Viejo"];
export const LIMPIEZA_OLF = ["Limpio", "Dudoso", "Defectuoso"];
export const PRIMERA_IMPRESION_OLF = ["Cerrado", "Discreto", "Expresivo", "Muy expresivo"];
export const INTENSIDAD_5 = ["Muy baja", "Baja", "Media", "Alta", "Muy alta"];
export const CARACTER_AROMATICO = ["Frutal", "Floral", "Mineral", "Herbal", "Balsámico", "Especiado", "Complejo", "Maduro", "Evolucionado"];
export const DEFECTOS = ["Corcho", "Oxidado", "Brett", "Acético", "Sulfuroso", "Reducción", "Otro"];
export const TIPO_BARRICA = ["Roble Francés", "Roble Americano", "Roble Húngaro", "Otro"];
export const NIVEL_TOSTADO = ["Ligero", "Medio", "Alto"];

export const AROMAS = {
  Frutales: ["Manzana", "Pera", "Melocotón", "Cítricos", "Fresa", "Frambuesa", "Cereza", "Ciruela", "Mora", "Fruta tropical", "Higo", "Frutos secos"],
  Florales: ["Rosa", "Violeta", "Jazmín", "Azahar", "Acacia", "Manzanilla", "Lavanda"],
  Herbáceos: ["Hierba fresca", "Heno", "Pimiento verde", "Eucalipto", "Menta", "Tomillo", "Romero"],
  Especiados: ["Pimienta negra", "Canela", "Clavo", "Vainilla", "Nuez moscada", "Regaliz", "Anís"],
  Minerales: ["Piedra mojada", "Grafito", "Tiza", "Pedernal", "Petróleo", "Yodo"],
  Balsámicos: ["Resina", "Pino", "Alquitrán", "Cedro", "Incienso"],
  Fermentativos: ["Levadura", "Pan", "Lácteos", "Mantequilla", "Plátano", "Caramelo"],
  Crianza: ["Tostado", "Café", "Cacao", "Tabaco", "Cuero", "Coco", "Ahumado", "Chocolate"],
};

// ---- GUSTATIVO ----
export const DULZOR = ["Seco", "Semi seco", "Semi dulce", "Dulce"];
export const PRIMERA_IMPRESION_GUS = ["Muy agradable", "Agradable", "Ordinaria", "Desagradable"];
export const EQUILIBRIO = ["Muy desequilibrado", "Desequilibrado", "Correcto", "Equilibrado", "Excelente"];
export const NIVEL_5 = ["Muy bajo", "Bajo", "Medio", "Alto", "Muy alto"];
export const ASTRINGENCIA = ["Nula", "Baja", "Media", "Alta"];
export const CUERPO = ["Ligero", "Medio", "Robusto"];
export const ESTADO_GUS = ["Joven", "Maduro", "Viejo"];
export const ESTILO = ["Nuevo Mundo", "Viejo Mundo"];
export const CALIDAD_3 = ["Baja", "Media", "Alta"];

// ---- ESTÁNDAR WSET (SAT) / CMS ----
// Desarrollo / Evolución en nariz (WSET "Development")
export const DESARROLLO = ["Juvenil", "En evolución", "Completamente evolucionado", "Pasado / En declive"];
// Clasificación de aromas (WSET / CMS)
export const TIPO_AROMAS = ["Primarios (varietal/frutal)", "Secundarios (fermentación/crianza)", "Terciarios (evolución)"];
// Intensidad de sabor en boca (WSET "Flavour intensity")
export const INTENSIDAD_SABOR = ["Ligera", "Media (-)", "Media", "Media (+)", "Pronunciada"];
// Longitud del final (WSET "Finish")
export const FINAL_LONGITUD = ["Corto", "Medio (-)", "Medio", "Medio (+)", "Largo"];
// Nivel de calidad (WSET "Quality level")
export const NIVEL_CALIDAD = ["Defectuoso", "Pobre", "Aceptable", "Bueno", "Muy bueno", "Excepcional"];
// Nivel de consumo / potencial de guarda (WSET "Readiness for drinking")
export const CONSUMO_GUARDA = ["Demasiado joven", "Beber ahora: sin potencial de guarda", "Beber ahora: con potencial de guarda", "Demasiado viejo"];
// Clima estimado (CMS deductive)
export const CLIMA = ["Frío", "Templado", "Cálido"];

// Autorelleno de la longitud del final según las caudalías (persistencia)
export function finalFromCaudalias(value) {
  const n = parseFloat(value);
  if (value === "" || value == null || Number.isNaN(n)) return "";
  if (n <= 3) return "Corto";
  if (n <= 5) return "Medio (-)";
  if (n <= 6) return "Medio";
  if (n < 8) return "Medio (+)";
  return "Largo";
}

export function categoriaPuntuacion(score) {
  if (score < 50) return { label: "Defectuoso", color: "#4E070C" };
  if (score < 60) return { label: "Malo", color: "#800020" };
  if (score < 70) return { label: "Regular", color: "#B8860B" };
  if (score < 80) return { label: "Bueno", color: "#C5A059" };
  if (score < 90) return { label: "Muy Bueno", color: "#722F37" };
  if (score < 95) return { label: "Excelente", color: "#D4AF37" };
  return { label: "Extraordinario", color: "#D4AF37" };
}

export function colorOptionsFor(tipo) {
  if (tipo === "Blanco") return COLOR_BLANCO;
  if (tipo === "Rosado") return COLOR_ROSADO;
  if (tipo === "Tinto") return COLOR_TINTO;
  return [...new Set([...COLOR_BLANCO, ...COLOR_ROSADO, ...COLOR_TINTO])];
}
